
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $b0ce1a182b084c50$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["3MdnK","index.1ad312ab.js","jE0mJ","../carte-topo.c072b3db.png","fBSJf","../mic.d05ce39f.png","aZT1Q","../TestLR.c41b1ab3.m4a","IMeJm","../SoundEscape.ddf2b7c4.m4a","bheYR","../DescriptionAlo.e3845da4.m4a","4FZsO","../DescriptionBern.3fbe4433.m4a","avEiC","../DescriptionIsa.f07d445e.m4a","lXM1v","../DescriptionLeon.433bd7ac.m4a","k6hdW","../DescriptionLouve.f90e36c0.m4a","aUrXh","../DescriptionMic.9f0ecbff.m4a","gaOIr","../DescriptionNico.3671b546.m4a","eoFhy","../DescriptionVJ.66bb408d.m4a","asqzZ","../DescriptionYves.aaa963cc.m4a"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $f320b2b2d3336a88$exports = {};

$parcel$export($f320b2b2d3336a88$exports, "load", function () { return $f320b2b2d3336a88$export$11e63f7b0f3d9900; });
$parcel$export($f320b2b2d3336a88$exports, "play", function () { return $f320b2b2d3336a88$export$899fbdb5fa08b653; });
$parcel$export($f320b2b2d3336a88$exports, "audioBuffers", function () { return $f320b2b2d3336a88$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $f320b2b2d3336a88$export$c2a342ec653dfb48 = {};
function $f320b2b2d3336a88$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($f320b2b2d3336a88$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $f320b2b2d3336a88$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $80117c5d5b1bbb46$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $f320b2b2d3336a88$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $f320b2b2d3336a88$export$899fbdb5fa08b653(name, options = {}) {
    if ($f320b2b2d3336a88$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $80117c5d5b1bbb46$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $80117c5d5b1bbb46$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $80117c5d5b1bbb46$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($80117c5d5b1bbb46$export$33ed28de027e9482(options.initialGain), $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $80117c5d5b1bbb46$export$549ee30ac73cf40b; // custom function
    source.fade = $80117c5d5b1bbb46$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $80117c5d5b1bbb46$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $f320b2b2d3336a88$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $80117c5d5b1bbb46$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $80117c5d5b1bbb46$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $80117c5d5b1bbb46$export$a078c61943f9dbbe;
const $80117c5d5b1bbb46$export$d1d41f0cda037248 = [];
function $80117c5d5b1bbb46$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $80117c5d5b1bbb46$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $80117c5d5b1bbb46$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $80117c5d5b1bbb46$export$a078c61943f9dbbe.sampleRate);
}
function $80117c5d5b1bbb46$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($80117c5d5b1bbb46$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $80117c5d5b1bbb46$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $80117c5d5b1bbb46$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($80117c5d5b1bbb46$export$33ed28de027e9482(fromLevel), $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($80117c5d5b1bbb46$export$33ed28de027e9482(level), $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($80117c5d5b1bbb46$export$33ed28de027e9482(level), $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $80117c5d5b1bbb46$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $80117c5d5b1bbb46$export$33ed28de027e9482(db), $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $80117c5d5b1bbb46$export$33ed28de027e9482(db), $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $80117c5d5b1bbb46$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $80117c5d5b1bbb46$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $80117c5d5b1bbb46$export$33390c3a9a83a2f() {
    $80117c5d5b1bbb46$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $80117c5d5b1bbb46$export$93c25f2590a5b540(source) {
    const index = $80117c5d5b1bbb46$export$d1d41f0cda037248.indexOf(source);
    $80117c5d5b1bbb46$export$d1d41f0cda037248.splice(index, 1);
}
function $80117c5d5b1bbb46$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $80117c5d5b1bbb46$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}




let $d3bb6e6a9687f858$var$testHeadphone;
function $d3bb6e6a9687f858$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".headphone").classList.add("hidden");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $80117c5d5b1bbb46$export$fbb4d68fe60c1629().then(()=>{
            if ($d3bb6e6a9687f858$var$testHeadphone) $d3bb6e6a9687f858$var$testHeadphone.fade(1);
            $2038d9b28e35f765$export$b3571188c770cc5a();
        });
    });
    document.querySelector(".js-test-headphone").addEventListener("click", $d3bb6e6a9687f858$var$testHeadphones);
}
function $d3bb6e6a9687f858$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $d3bb6e6a9687f858$export$4bb981a91e4f02eb() {
    document.querySelector(".headphone").classList.remove("hidden");
    document.querySelector(".js-start").classList.remove("hidden");
    $d3bb6e6a9687f858$export$471f7ae5c4103ae1(null);
}
function $d3bb6e6a9687f858$var$testHeadphones() {
    const leftIndicator = document.querySelector(".test-headphone-left");
    const rightIndicator = document.querySelector(".test-headphone-right");
    $80117c5d5b1bbb46$export$fbb4d68fe60c1629().then(()=>{
        $d3bb6e6a9687f858$var$testHeadphone = $f320b2b2d3336a88$exports.play("test-headphone", {
            onended: ()=>{
                rightIndicator.style.opacity = 0;
            }
        });
    });
    leftIndicator.style.opacity = 1;
    setTimeout(()=>{
        leftIndicator.style.opacity = 0;
        rightIndicator.style.opacity = 1;
    }, 8000);
}



// Audio kernel module: Panner
// Manages audiospatialisation

function $fc33fd160a04e587$export$604289ae06b8fa82(options = {}) {
    const panner = $80117c5d5b1bbb46$export$a078c61943f9dbbe.createPanner();
    panner.panningModel = "HRTF";
    panner.distanceModel = "inverse";
    panner.refDistance = 20;
    panner.maxDistance = 2000;
    panner.rolloffFactor = 1;
    panner.coneInnerAngle = 360;
    panner.coneOuterAngle = 0;
    panner.coneOuterGain = 0;
    if (panner.orientationX) {
        panner.orientationX.setValueAtTime(0, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        panner.orientationY.setValueAtTime(0, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        panner.orientationZ.setValueAtTime(-1, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
    } else panner.setOrientation(0, 0, -1);
    panner.positionPanner = function(x, y, z) {
        if (panner.positionX) {
            panner.positionX.setValueAtTime(x, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
            panner.positionY.setValueAtTime(y, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
            panner.positionZ.setValueAtTime(z, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        } else panner.setPosition(x, y, z);
    };
    panner.connect(options.destination || $80117c5d5b1bbb46$export$a078c61943f9dbbe.destination);
    return panner;
}
function $fc33fd160a04e587$export$f0551cbb67220cad(x, y, z) {
    const listener = $80117c5d5b1bbb46$export$a078c61943f9dbbe.listener;
    if (listener.positionX) {
        listener.positionX.setValueAtTime(x, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.positionY.setValueAtTime(y, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.positionZ.setValueAtTime(z, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
    } else listener.setPosition(x, y, z);
}
function $fc33fd160a04e587$export$27298482267e128c(fx, fy, fz = -1, ux = 0, uy = 1, uz = 0) {
    const listener = $80117c5d5b1bbb46$export$a078c61943f9dbbe.listener;
    if (listener.forwardX) {
        listener.forwardX.setValueAtTime(fx, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.forwardY.setValueAtTime(fy, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.forwardZ.setValueAtTime(fz, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.upX.setValueAtTime(ux, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.upY.setValueAtTime(uy, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
        listener.upZ.setValueAtTime(uz, $80117c5d5b1bbb46$export$a078c61943f9dbbe.currentTime);
    } else listener.setOrientation(fx, fy, fz, ux, uy, uz);
}


/* eslint-disable no-use-before-define */ // Frequency Spectrum Visualisation Module
//
// Draws a live audio FFT horizontaly
// TODO:
// [] Add ability to reduce the bins drawn (divider?)
// [] Add a switch to display linear/exponential FFT
// [] Add smoothing option
// [] Add identification of signal spikes
// Utilities
//
// Project-wide utility functions
function $212233a136f1e6f6$export$10ce5528abfb398a(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key)=>{
        if (Object.prototype.hasOwnProperty.call(source, key)) dest[key] = source[key];
    });
}
// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function $212233a136f1e6f6$export$89440da1893f4202(str, length) {
    const lines = [];
    if (str.length <= length) lines.push(str);
    else {
        let s = str;
        while(s.length > 0){
            let line;
            if (s.length > length) line = s.slice(0, s.slice(0, length).lastIndexOf(" "));
            else line = s;
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else s = "";
        }
    }
    return lines;
}
function $212233a136f1e6f6$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}
function $212233a136f1e6f6$var$constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
}
let $212233a136f1e6f6$var$newval;
function $212233a136f1e6f6$export$aee1dbae5de2db9d(n, start1, stop1, start2, stop2, withinBounds) {
    $212233a136f1e6f6$var$newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) return $212233a136f1e6f6$var$newval;
    if (start2 < stop2) return $212233a136f1e6f6$var$constrain($212233a136f1e6f6$var$newval, start2, stop2);
    return $212233a136f1e6f6$var$constrain($212233a136f1e6f6$var$newval, stop2, start2);
}
function $212233a136f1e6f6$export$2313b1b8de5d93a7(val) {
    return val * (100 / 1920) + "vw";
}
function $212233a136f1e6f6$export$e6bfdeff8bfc94f9(deg) {
    return deg * Math.PI / 180;
}


let $9a129a1bee9f3e65$var$offscreen;
let $9a129a1bee9f3e65$var$ctx;
let $9a129a1bee9f3e65$var$width;
let $9a129a1bee9f3e65$var$height;
let $9a129a1bee9f3e65$var$divider;
// Module-global variables pulled out of their functions for better memory managment
let $9a129a1bee9f3e65$var$i; // Used in draw()
let $9a129a1bee9f3e65$var$x;
let $9a129a1bee9f3e65$var$h; // Used in draw()
// Default options
const $9a129a1bee9f3e65$var$options = {
    background: "transparent",
    color: "#ff8800",
    fftBins: 1024,
    noiseFloor: -140,
    lowerFreq: 0,
    upperFreq: 20000,
    gateThreshold: -50,
    detectionLineWidth: 2
};
function $9a129a1bee9f3e65$export$de27182ff8187d6c({ cellWidth: cellWidth, cellHeight: cellHeight, devicePixelRatio: devicePixelRatio }) {
    // Save these dimensions as module-scoped variables
    $9a129a1bee9f3e65$var$width = cellWidth * devicePixelRatio;
    $9a129a1bee9f3e65$var$height = cellHeight * devicePixelRatio;
    // Create an offscreen graphics buffer to draw in
    $9a129a1bee9f3e65$var$offscreen = new OffscreenCanvas($9a129a1bee9f3e65$var$width, $9a129a1bee9f3e65$var$height);
    $9a129a1bee9f3e65$var$ctx = $9a129a1bee9f3e65$var$offscreen.getContext("2d");
    // Fill in the background with a solid color
    $9a129a1bee9f3e65$var$ctx.fillStyle = $9a129a1bee9f3e65$var$options.background;
    $9a129a1bee9f3e65$var$ctx.clearRect(0, 0, $9a129a1bee9f3e65$var$width, $9a129a1bee9f3e65$var$height);
    // Set up some constants
    $9a129a1bee9f3e65$var$divider = 24000 / $9a129a1bee9f3e65$var$options.upperFreq;
}
function $9a129a1bee9f3e65$export$e529deb2bfd496dc(spectrumData) {
    if (spectrumData) {
        // Erase the graphics buffer with background color
        $9a129a1bee9f3e65$var$ctx.fillStyle = $9a129a1bee9f3e65$var$options.background;
        $9a129a1bee9f3e65$var$ctx.clearRect(0, 0, $9a129a1bee9f3e65$var$width, $9a129a1bee9f3e65$var$height);
        // Set FFT style
        $9a129a1bee9f3e65$var$ctx.fillStyle = $9a129a1bee9f3e65$var$options.color;
        // Draw FFT
        for($9a129a1bee9f3e65$var$i = 0; $9a129a1bee9f3e65$var$i < spectrumData.length / $9a129a1bee9f3e65$var$divider; $9a129a1bee9f3e65$var$i++){
            $9a129a1bee9f3e65$var$x = (0, $212233a136f1e6f6$export$aee1dbae5de2db9d)($9a129a1bee9f3e65$var$i, 0, $9a129a1bee9f3e65$var$options.fftBins / $9a129a1bee9f3e65$var$divider, 0, $9a129a1bee9f3e65$var$width);
            $9a129a1bee9f3e65$var$h = -$9a129a1bee9f3e65$var$height + (0, $212233a136f1e6f6$export$aee1dbae5de2db9d)(spectrumData[$9a129a1bee9f3e65$var$i], $9a129a1bee9f3e65$var$options.noiseFloor, 0, $9a129a1bee9f3e65$var$height, 0, true);
            $9a129a1bee9f3e65$var$ctx.fillRect($9a129a1bee9f3e65$var$x, $9a129a1bee9f3e65$var$height, $9a129a1bee9f3e65$var$width / spectrumData.length * $9a129a1bee9f3e65$var$divider, $9a129a1bee9f3e65$var$h);
        }
    }
    return $9a129a1bee9f3e65$var$offscreen.transferToImageBitmap();
}


// Waveform Visualisation Module
//
// Draws a live audio waveform horizontaly
// TODO:
// [] Make the waveform height exponential and constrained to the canvas height
// [] Add an option for a gain on waveform height

let $01ca5ca999366089$var$offscreen;
let $01ca5ca999366089$var$ctx;
let $01ca5ca999366089$var$width;
let $01ca5ca999366089$var$height;
// Module-global variables pulled out of their functions for better memory managment
let $01ca5ca999366089$var$i;
let $01ca5ca999366089$var$x;
let $01ca5ca999366089$var$y; // Used in draw()
const $01ca5ca999366089$var$options = {
    background: "black",
    color: "#ff8800",
    adaptPixelRatio: true,
    waveformLineWidth: 1
};
function $01ca5ca999366089$export$de27182ff8187d6c({ cellWidth: cellWidth, cellHeight: cellHeight, devicePixelRatio: devicePixelRatio }) {
    // Save these dimensions as module-scoped variables
    $01ca5ca999366089$var$width = cellWidth * devicePixelRatio;
    $01ca5ca999366089$var$height = cellHeight * devicePixelRatio;
    if ($01ca5ca999366089$var$options.adaptPixelRatio) {
        $01ca5ca999366089$var$width = cellWidth * devicePixelRatio;
        $01ca5ca999366089$var$height = cellHeight * devicePixelRatio;
        $01ca5ca999366089$var$options.waveformLineWidth *= devicePixelRatio;
    } else {
        $01ca5ca999366089$var$width = cellWidth;
        $01ca5ca999366089$var$height = cellHeight;
    }
    // Create an offscreen graphics buffer to draw in
    $01ca5ca999366089$var$offscreen = new OffscreenCanvas($01ca5ca999366089$var$width, $01ca5ca999366089$var$height);
    $01ca5ca999366089$var$ctx = $01ca5ca999366089$var$offscreen.getContext("2d");
    // Fill in the background with a solid color
    $01ca5ca999366089$var$ctx.fillStyle = $01ca5ca999366089$var$options.background;
    $01ca5ca999366089$var$ctx.clearRect(0, 0, $01ca5ca999366089$var$width, $01ca5ca999366089$var$height);
}
function $01ca5ca999366089$export$e529deb2bfd496dc(waveformData) {
    if (waveformData) {
        // Erase the graphics buffer with background color
        $01ca5ca999366089$var$ctx.clearRect(0, 0, $01ca5ca999366089$var$width, $01ca5ca999366089$var$height);
        // Set waveform style
        $01ca5ca999366089$var$ctx.strokeStyle = $01ca5ca999366089$var$options.color;
        $01ca5ca999366089$var$ctx.lineWidth = $01ca5ca999366089$var$options.waveformLineWidth;
        // Draw waveform
        $01ca5ca999366089$var$ctx.beginPath();
        for($01ca5ca999366089$var$i = 0; $01ca5ca999366089$var$i < waveformData.length; $01ca5ca999366089$var$i++){
            $01ca5ca999366089$var$x = (0, $212233a136f1e6f6$export$aee1dbae5de2db9d)($01ca5ca999366089$var$i, 0, waveformData.length, 0, $01ca5ca999366089$var$width);
            $01ca5ca999366089$var$y = (0, $212233a136f1e6f6$export$aee1dbae5de2db9d)(waveformData[$01ca5ca999366089$var$i] * 8, -1, 1, 0, $01ca5ca999366089$var$height); // FIXME: this * 8 is hacky, dig in...
            $01ca5ca999366089$var$ctx.lineTo($01ca5ca999366089$var$x, $01ca5ca999366089$var$y);
        }
        $01ca5ca999366089$var$ctx.stroke();
        $01ca5ca999366089$var$ctx.closePath();
    }
    return $01ca5ca999366089$var$offscreen.transferToImageBitmap();
}



var $8d5a71f38da32ece$exports = {};
$8d5a71f38da32ece$exports = new URL("../carte-topo.c072b3db.png", import.meta.url).toString();


var $d6f053433d32e707$exports = {};
$d6f053433d32e707$exports = new URL("../mic.d05ce39f.png", import.meta.url).toString();


const $839b5a96544d2aa5$var$images = [
    {
        name: "background",
        url: new URL($8d5a71f38da32ece$exports)
    },
    {
        name: "mic",
        url: new URL($d6f053433d32e707$exports)
    }
];
var $7cabaf2d33b07291$exports = {};
$7cabaf2d33b07291$exports = new URL("../TestLR.c41b1ab3.m4a", import.meta.url).toString();


var $cc15faf0cd946e1f$exports = {};
$cc15faf0cd946e1f$exports = new URL("../SoundEscape.ddf2b7c4.m4a", import.meta.url).toString();


var $926ddba4c2bef189$exports = {};
$926ddba4c2bef189$exports = new URL("../DescriptionAlo.e3845da4.m4a", import.meta.url).toString();


var $7d89f5b4483f9758$exports = {};
$7d89f5b4483f9758$exports = new URL("../DescriptionBern.3fbe4433.m4a", import.meta.url).toString();


var $a85944191cb6ab94$exports = {};
$a85944191cb6ab94$exports = new URL("../DescriptionIsa.f07d445e.m4a", import.meta.url).toString();


var $631ab447583917b8$exports = {};
$631ab447583917b8$exports = new URL("../DescriptionLeon.433bd7ac.m4a", import.meta.url).toString();


var $d1f200e32b46abdf$exports = {};
$d1f200e32b46abdf$exports = new URL("../DescriptionLouve.f90e36c0.m4a", import.meta.url).toString();


var $c3f3cc873a6f13f7$exports = {};
$c3f3cc873a6f13f7$exports = new URL("../DescriptionMic.9f0ecbff.m4a", import.meta.url).toString();


var $53896e591466c399$exports = {};
$53896e591466c399$exports = new URL("../DescriptionNico.3671b546.m4a", import.meta.url).toString();


var $6e9e09c528b5c69e$exports = {};
$6e9e09c528b5c69e$exports = new URL("../DescriptionVJ.66bb408d.m4a", import.meta.url).toString();


var $c0b8ecf92d0bd7b9$exports = {};
$c0b8ecf92d0bd7b9$exports = new URL("../DescriptionYves.aaa963cc.m4a", import.meta.url).toString();


const $839b5a96544d2aa5$var$sounds = [
    {
        name: "test-headphone",
        url: new URL($7cabaf2d33b07291$exports)
    },
    {
        name: "signal",
        url: new URL($cc15faf0cd946e1f$exports)
    },
    {
        name: "commentaire1",
        url: new URL($926ddba4c2bef189$exports)
    },
    {
        name: "commentaire2",
        url: new URL($7d89f5b4483f9758$exports)
    },
    {
        name: "commentaire3",
        url: new URL($a85944191cb6ab94$exports)
    },
    {
        name: "commentaire4",
        url: new URL($631ab447583917b8$exports)
    },
    {
        name: "commentaire5",
        url: new URL($d1f200e32b46abdf$exports)
    },
    {
        name: "commentaire6",
        url: new URL($c3f3cc873a6f13f7$exports)
    },
    {
        name: "commentaire7",
        url: new URL($53896e591466c399$exports)
    },
    {
        name: "commentaire8",
        url: new URL($6e9e09c528b5c69e$exports)
    },
    {
        name: "commentaire9",
        url: new URL($c0b8ecf92d0bd7b9$exports)
    }
];
const $839b5a96544d2aa5$var$commentaries = [
    {
        name: "commentaire1",
        x: 510,
        y: 275
    },
    {
        name: "commentaire2",
        x: 420,
        y: 370
    },
    {
        name: "commentaire3",
        x: 400,
        y: 735
    },
    {
        name: "commentaire4",
        x: 635,
        y: 240
    },
    {
        name: "commentaire5",
        x: 760,
        y: 685
    },
    {
        name: "commentaire6",
        x: 1345,
        y: 205
    },
    {
        name: "commentaire7",
        x: 1445,
        y: 435
    },
    {
        name: "commentaire8",
        x: 1480,
        y: 260
    },
    {
        name: "commentaire9",
        x: 1245,
        y: 810
    },
    {
        name: "commentaire1",
        x: 1909,
        y: 93
    },
    {
        name: "commentaire2",
        x: 1888,
        y: 847
    },
    {
        name: "commentaire3",
        x: 1088,
        y: 356
    },
    {
        name: "commentaire4",
        x: 96,
        y: 894
    },
    {
        name: "commentaire5",
        x: 1807,
        y: 108
    },
    {
        name: "commentaire6",
        x: 596,
        y: 886
    },
    {
        name: "commentaire7",
        x: 102,
        y: 433
    },
    {
        name: "commentaire8",
        x: 746,
        y: 940
    },
    {
        name: "commentaire9",
        x: 1013,
        y: 63
    }
];
const $839b5a96544d2aa5$var$screen = document.querySelector(".screen");
const $839b5a96544d2aa5$var$micEl = document.querySelector(".mic");
const $839b5a96544d2aa5$var$joystickEl = document.querySelector(".joystick");
const $839b5a96544d2aa5$var$worldSize = {
    width: 3840,
    height: 2160
};
const $839b5a96544d2aa5$var$joystickSize = 60;
const $839b5a96544d2aa5$var$commentarySize = 12;
const $839b5a96544d2aa5$var$mic = {
    position: {
        x: 611,
        y: 412
    },
    rotation: -11,
    damping: 0.08,
    speed: 0,
    turnSpeed: 0,
    acceleration: 0.1
};
const $839b5a96544d2aa5$var$positionOffset = {
    x: 0,
    y: 0
};
const $839b5a96544d2aa5$var$coordinatesMultiplier = 2; // Coordinates are in FHD, world is in 4K
const $839b5a96544d2aa5$var$keys = {};
const $839b5a96544d2aa5$var$touch = {
    active: false,
    startX: 0,
    startY: 0,
    xAxis: 0,
    yAxis: 0
};
function $839b5a96544d2aa5$export$2cd8252107eb640b() {
    // Register window resize event
    window.addEventListener("resize", ()=>{
        $839b5a96544d2aa5$var$updateMicElPos();
        $839b5a96544d2aa5$var$updateCommentariesPos();
    });
    // Register keyboard events
    window.addEventListener("keydown", (e)=>{
        $839b5a96544d2aa5$var$keys[e.key] = true;
    });
    window.addEventListener("keyup", (e)=>{
        $839b5a96544d2aa5$var$keys[e.key] = false;
    });
    // Register touch events
    window.addEventListener("touchstart", (e)=>{
        $839b5a96544d2aa5$var$touch.active = true;
        $839b5a96544d2aa5$var$touch.startX = e.touches[0].clientX;
        $839b5a96544d2aa5$var$touch.startY = e.touches[0].clientY;
        $839b5a96544d2aa5$var$joystickEl.style.translate = `${$839b5a96544d2aa5$var$touch.startX - $839b5a96544d2aa5$var$joystickSize / 2}px ${$839b5a96544d2aa5$var$touch.startY - $839b5a96544d2aa5$var$joystickSize / 2}px`;
        $839b5a96544d2aa5$var$joystickEl.style.opacity = 0.5;
    });
    window.addEventListener("touchmove", (e)=>{
        const halfJoy = $839b5a96544d2aa5$var$joystickSize / 2;
        // Get touch move position
        let moveX = e.touches[0].clientX;
        let moveY = e.touches[0].clientY;
        // Calculate joystick delta
        let deltaX = moveX - $839b5a96544d2aa5$var$touch.startX;
        let deltaY = moveY - $839b5a96544d2aa5$var$touch.startY;
        // Calculate joystick distance
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
        // Constrain joystick to its size
        if (distance > halfJoy) {
            const angle = Math.atan2(deltaY, deltaX);
            deltaX = Math.cos(angle) * halfJoy;
            deltaY = Math.sin(angle) * halfJoy;
            moveX = $839b5a96544d2aa5$var$touch.startX + deltaX;
            moveY = $839b5a96544d2aa5$var$touch.startY + deltaY;
        }
        $839b5a96544d2aa5$var$touch.xAxis = deltaX / halfJoy;
        $839b5a96544d2aa5$var$touch.yAxis = deltaY / halfJoy;
        // Update joystick position
        $839b5a96544d2aa5$var$joystickEl.style.translate = `${moveX - halfJoy}px ${moveY - halfJoy}px`;
    });
    window.addEventListener("touchend", (e)=>{
        $839b5a96544d2aa5$var$touch.active = false;
        $839b5a96544d2aa5$var$joystickEl.style.opacity = 0;
    });
}
function $839b5a96544d2aa5$export$11e63f7b0f3d9900() {
    return Promise.all([
        $839b5a96544d2aa5$var$loadSounds(),
        $839b5a96544d2aa5$var$loadImages()
    ]);
}
function $839b5a96544d2aa5$export$b3571188c770cc5a() {
    if (DEVMODE) console.log("Scene started");
    $839b5a96544d2aa5$var$updateMicElPos();
    // Play signal
    const signal = $f320b2b2d3336a88$exports.play("signal", {
        loop: true
    });
    // Setup spectrum audio analyser
    const spectrumAudioAnalyser = $80117c5d5b1bbb46$export$a078c61943f9dbbe.createAnalyser();
    const fftBins = 1024;
    spectrumAudioAnalyser.fftSize = fftBins * 2;
    spectrumAudioAnalyser.smoothingTimeConstant = 0.0;
    const spectrumData = new Float32Array(fftBins);
    signal.gainNode.connect(spectrumAudioAnalyser);
    // Setup spectrum module
    const spectrumCanvas = document.querySelector("#spectrum");
    spectrumCanvas.width = 250;
    spectrumCanvas.height = 74;
    $9a129a1bee9f3e65$export$de27182ff8187d6c({
        cellWidth: spectrumCanvas.width,
        cellHeight: spectrumCanvas.height,
        devicePixelRatio: 1
    });
    // Get spectrum canvas context
    const spectrumCtx = spectrumCanvas.getContext("2d");
    // Setup waveform module
    const waveformCanvas = document.querySelector("#waveform");
    waveformCanvas.width = 250;
    waveformCanvas.height = 74;
    $01ca5ca999366089$export$de27182ff8187d6c({
        cellWidth: waveformCanvas.width,
        cellHeight: waveformCanvas.height,
        devicePixelRatio: 1
    });
    // Get waveform canvas context
    const waveformCtx = waveformCanvas.getContext("2d");
    // Setup waveform audio analyser
    const waveformAudioAnalyser = $80117c5d5b1bbb46$export$a078c61943f9dbbe.createAnalyser();
    spectrumAudioAnalyser.fftSize = fftBins * 2;
    spectrumAudioAnalyser.smoothingTimeConstant = 0.0;
    const waveformData = new Float32Array(fftBins);
    $839b5a96544d2aa5$var$commentaries.forEach((commentary)=>{
        // Create panner
        const panner = (0, $fc33fd160a04e587$export$604289ae06b8fa82)();
        panner.positionPanner(commentary.x, 0, commentary.y);
        // Play commentaries
        const sound = $f320b2b2d3336a88$exports.play(commentary.name, {
            loop: true,
            destination: panner
        });
        panner.connect(waveformAudioAnalyser);
        // Add commentary to the screen
        const el = document.createElement("div");
        el.classList.add("commentary");
        el.classList.add(commentary.name);
        $839b5a96544d2aa5$var$screen.appendChild(el);
        commentary.el = el;
    });
    $839b5a96544d2aa5$var$updateCommentariesPos();
    loop();
    function loop() {
        // Update mic speed and rotation from keyboard
        if ($839b5a96544d2aa5$var$keys.ArrowUp) $839b5a96544d2aa5$var$mic.speed += $839b5a96544d2aa5$var$mic.acceleration;
        if ($839b5a96544d2aa5$var$keys.ArrowDown) $839b5a96544d2aa5$var$mic.speed -= $839b5a96544d2aa5$var$mic.acceleration;
        if ($839b5a96544d2aa5$var$keys.ArrowLeft) $839b5a96544d2aa5$var$mic.turnSpeed -= $839b5a96544d2aa5$var$mic.acceleration;
        if ($839b5a96544d2aa5$var$keys.ArrowRight) $839b5a96544d2aa5$var$mic.turnSpeed += $839b5a96544d2aa5$var$mic.acceleration;
        // Update mic speed and rotation from touch
        if ($839b5a96544d2aa5$var$touch.active) {
            $839b5a96544d2aa5$var$mic.speed += $839b5a96544d2aa5$var$mic.acceleration * -$839b5a96544d2aa5$var$touch.yAxis;
            $839b5a96544d2aa5$var$mic.turnSpeed += $839b5a96544d2aa5$var$mic.acceleration * $839b5a96544d2aa5$var$touch.xAxis;
        }
        // Update mic
        $839b5a96544d2aa5$var$mic.speed *= 1 - $839b5a96544d2aa5$var$mic.damping;
        $839b5a96544d2aa5$var$mic.turnSpeed *= 1 - $839b5a96544d2aa5$var$mic.damping;
        $839b5a96544d2aa5$var$mic.position.x += Math.cos((0, $212233a136f1e6f6$export$e6bfdeff8bfc94f9)($839b5a96544d2aa5$var$mic.rotation - 90)) * $839b5a96544d2aa5$var$mic.speed;
        $839b5a96544d2aa5$var$mic.position.y += Math.sin((0, $212233a136f1e6f6$export$e6bfdeff8bfc94f9)($839b5a96544d2aa5$var$mic.rotation - 90)) * $839b5a96544d2aa5$var$mic.speed;
        $839b5a96544d2aa5$var$mic.rotation += $839b5a96544d2aa5$var$mic.turnSpeed;
        // Constrain position to topographic map boundaries
        const margin = 20;
        $839b5a96544d2aa5$var$mic.position.x = Math.max(margin, Math.min($839b5a96544d2aa5$var$mic.position.x, $839b5a96544d2aa5$var$worldSize.width / $839b5a96544d2aa5$var$coordinatesMultiplier - margin));
        $839b5a96544d2aa5$var$mic.position.y = Math.max(margin, Math.min($839b5a96544d2aa5$var$mic.position.y, $839b5a96544d2aa5$var$worldSize.height / $839b5a96544d2aa5$var$coordinatesMultiplier - margin));
        // Offset background position, mic position and commentaries position
        // when mic is near the edge of the screen
        const screenPos = $839b5a96544d2aa5$var$worldToScreenPosition($839b5a96544d2aa5$var$mic.position);
        if (screenPos.x < $839b5a96544d2aa5$var$screen.clientWidth / 4) $839b5a96544d2aa5$var$positionOffset.x = $839b5a96544d2aa5$var$screen.clientWidth / 4 - screenPos.x;
        else if (screenPos.x > $839b5a96544d2aa5$var$screen.clientWidth * 3 / 4) $839b5a96544d2aa5$var$positionOffset.x = $839b5a96544d2aa5$var$screen.clientWidth * 3 / 4 - screenPos.x;
        else $839b5a96544d2aa5$var$positionOffset.x = 0;
        if (screenPos.y < $839b5a96544d2aa5$var$screen.clientHeight / 4) $839b5a96544d2aa5$var$positionOffset.y = $839b5a96544d2aa5$var$screen.clientHeight / 4 - screenPos.y;
        else if (screenPos.y > $839b5a96544d2aa5$var$screen.clientHeight * 3 / 4) $839b5a96544d2aa5$var$positionOffset.y = $839b5a96544d2aa5$var$screen.clientHeight * 3 / 4 - screenPos.y;
        else $839b5a96544d2aa5$var$positionOffset.y = 0;
        $839b5a96544d2aa5$var$screen.style.backgroundPosition = `calc(50% + ${$839b5a96544d2aa5$var$positionOffset.x}px) calc(50% + ${$839b5a96544d2aa5$var$positionOffset.y}px)`;
        $839b5a96544d2aa5$var$updateMicElPos();
        $839b5a96544d2aa5$var$updateCommentariesPos();
        // 3D HRTF panning
        (0, $fc33fd160a04e587$export$f0551cbb67220cad)($839b5a96544d2aa5$var$mic.position.x, 0, $839b5a96544d2aa5$var$mic.position.y);
        const deltaAngleX = Math.abs($839b5a96544d2aa5$var$mic.rotation + 90) % 360;
        const deviationX = deltaAngleX < 180 ? deltaAngleX : 360 - deltaAngleX;
        const deltaAngleZ = Math.abs($839b5a96544d2aa5$var$mic.rotation) % 360;
        const deviationZ = deltaAngleZ < 180 ? deltaAngleZ : 360 - deltaAngleZ;
        (0, $fc33fd160a04e587$export$27298482267e128c)(deviationX / 180 * 2 - 1, 0, deviationZ / 180 * 2 - 1);
        // Draw spectrum
        spectrumAudioAnalyser.getFloatFrequencyData(spectrumData);
        spectrumCtx.clearRect(0, 0, spectrumCanvas.width, spectrumCanvas.height);
        spectrumCtx.drawImage($9a129a1bee9f3e65$export$e529deb2bfd496dc(spectrumData), 0, 0);
        spectrumCtx.fillStyle = "#ff8800";
        spectrumCtx.font = "14px Source Code Pro";
        spectrumCtx.fillText(`Signal spectrum`, 5, 16);
        // Draw waveform
        waveformAudioAnalyser.getFloatTimeDomainData(waveformData);
        waveformCtx.clearRect(0, 0, waveformCanvas.width, waveformCanvas.height);
        waveformCtx.drawImage($01ca5ca999366089$export$e529deb2bfd496dc(waveformData), 0, 0);
        waveformCtx.fillStyle = "#ff8800";
        waveformCtx.font = "14px Source Code Pro";
        waveformCtx.fillText(`Microphone waveform`, 5, 16);
        requestAnimationFrame(loop);
    }
}
function $839b5a96544d2aa5$var$loadSounds() {
    return Promise.all([
        ...$839b5a96544d2aa5$var$sounds.map((sound)=>{
            return $f320b2b2d3336a88$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}
function $839b5a96544d2aa5$var$loadImages() {
    return Promise.all([
        ...$839b5a96544d2aa5$var$images.map((image)=>{
            return new Promise((resolve, reject)=>{
                const img = new Image();
                img.onload = ()=>{
                    if (DEVMODE) console.log(`Image ${image.name} loaded`);
                    resolve();
                };
                img.onerror = ()=>{
                    reject(`Error loading image ${image.name}`);
                };
                img.src = image.url;
            });
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All images loaded");
    });
}
function $839b5a96544d2aa5$var$updateMicElPos() {
    const screenPos = $839b5a96544d2aa5$var$worldToScreenPosition($839b5a96544d2aa5$var$mic.position);
    $839b5a96544d2aa5$var$micEl.style.translate = `${$839b5a96544d2aa5$var$positionOffset.x + screenPos.x}px ${$839b5a96544d2aa5$var$positionOffset.y + screenPos.y}px`;
    $839b5a96544d2aa5$var$micEl.style.rotate = `${$839b5a96544d2aa5$var$mic.rotation}deg`;
    $839b5a96544d2aa5$var$micEl.style.scale = `${screenPos.scale}`;
}
function $839b5a96544d2aa5$var$updateCommentariesPos() {
    $839b5a96544d2aa5$var$commentaries.forEach((commentary)=>{
        const screenPos = $839b5a96544d2aa5$var$worldToScreenPosition(commentary);
        commentary.el.style.translate = `${$839b5a96544d2aa5$var$positionOffset.x + screenPos.x - $839b5a96544d2aa5$var$commentarySize / 2}px ${$839b5a96544d2aa5$var$positionOffset.y + screenPos.y - $839b5a96544d2aa5$var$commentarySize / 2}px`;
        commentary.el.style.scale = `${screenPos.scale}`;
    });
}
function $839b5a96544d2aa5$var$worldToScreenPosition(worldPos) {
    // Screen background-size is set to cover
    const screenRatio = $839b5a96544d2aa5$var$screen.clientWidth / $839b5a96544d2aa5$var$screen.clientHeight;
    const worldRatio = $839b5a96544d2aa5$var$worldSize.width / $839b5a96544d2aa5$var$worldSize.height;
    let scale = 1;
    if (screenRatio > worldRatio) {
        // Screen less tall than the world
        // Topography is clipped on the top and bottom
        scale = $839b5a96544d2aa5$var$screen.clientWidth / $839b5a96544d2aa5$var$worldSize.width;
        return {
            x: $839b5a96544d2aa5$var$coordinatesMultiplier * worldPos.x * scale,
            y: $839b5a96544d2aa5$var$coordinatesMultiplier * worldPos.y * scale - ($839b5a96544d2aa5$var$worldSize.height * scale - $839b5a96544d2aa5$var$screen.clientHeight) / 2,
            scale: $839b5a96544d2aa5$var$coordinatesMultiplier * scale
        };
    } else {
        // Screen is less wide than the world
        // Topography is clipped on the sides
        scale = $839b5a96544d2aa5$var$screen.clientHeight / $839b5a96544d2aa5$var$worldSize.height;
        return {
            x: $839b5a96544d2aa5$var$coordinatesMultiplier * worldPos.x * scale - ($839b5a96544d2aa5$var$worldSize.width * scale - $839b5a96544d2aa5$var$screen.clientWidth) / 2,
            y: $839b5a96544d2aa5$var$coordinatesMultiplier * worldPos.y * scale,
            scale: $839b5a96544d2aa5$var$coordinatesMultiplier * scale
        };
    }
}


// Development
window.DEVMODE = true;
function $2038d9b28e35f765$var$init() {
    $d3bb6e6a9687f858$export$2cd8252107eb640b();
    $d3bb6e6a9687f858$export$471f7ae5c4103ae1("Initializing...");
    $80117c5d5b1bbb46$export$2cd8252107eb640b();
    $d3bb6e6a9687f858$export$471f7ae5c4103ae1("Loading...");
    $839b5a96544d2aa5$export$2cd8252107eb640b();
    $839b5a96544d2aa5$export$11e63f7b0f3d9900().then(()=>{
        $d3bb6e6a9687f858$export$4bb981a91e4f02eb();
    });
}
function $2038d9b28e35f765$export$b3571188c770cc5a() {
    $839b5a96544d2aa5$export$b3571188c770cc5a();
}
$2038d9b28e35f765$var$init();


//# sourceMappingURL=index.1ad312ab.js.map
